import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		padding: theme.spacing(2),
		height: `calc(100% - 48px)`,
		maxWidth: "100%", // ✅ Permitir ancho completo sin restricciones
		width: "100%", // ✅ Ancho completo
	},

	// WHY `auto` y no `hidden`: con el alto fijado a la pantalla, `hidden` CORTABA sin scroll todo
	// lo que no cabía (zoom 150-200 %, portátiles pequeños) en las páginas que pintan su contenido
	// directo, como la Agenda. Las listas con carga infinita no cambian: su panel `flex: 1` con
	// `overflowY: scroll` se encoge a lo disponible y sigue siendo él quien hace scroll (doc 0447, D8).
	contentWrapper: {
		height: "100%",
		minWidth: 0,
		overflowY: "auto",
		// Lo que no quepa a lo ancho (tablas, pestañas) se desplaza; nunca se pierde.
		overflowX: "auto",
		display: "flex",
		flexDirection: "column",
		width: "100%", // ✅ Ancho completo
	},
}));

const MainContainer = ({ children }) => {
	const classes = useStyles();

	return (
		<Container className={classes.mainContainer} maxWidth={false}> {/* ✅ maxWidth={false} para permitir ancho completo */}
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
